<template>
  <ModalDialog
    v-if="isShow"
    :title="$t('建立對戰')"
    :hide-cancel="true"
    :confirm-text="$t('建立對局')"
    :value="isShow"
    @input="onInput"
    @confirm="createLobby"
  >
    <LobbyCreateForm ref="lobbyCreateForm" />
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/Modal/ModalDialog.vue';
import LobbyCreateForm from '@/components/Pvp/LobbyCreateForm.vue';

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LobbyCreateForm,
    ModalDialog,
  },
  data() {
    return {
      isCreating: false,
    };
  },
  computed: {
    isShow() {
      return this.$store.state.env.isCreatePvpModalShow;
    },
  },
  methods: {
    async createLobby() {
      this.isCreating = true;
      await this.$refs.lobbyCreateForm.createRoom();
      this.isCreating = false;
      this.$store.commit('env/setIsCreatePvpModalShow', false);
      this.$store.commit('env/setIsSelectPvpActionModalShow', false);
    },
    onInput() {
      if (this.isCreating) return;
      this.$store.commit('env/setIsCreatePvpModalShow', false);
    },
  },
};
</script>

<style lang="scss" scoped></style>
